import React, { useState, useContext, useEffect } from "react";
import "../../../styles/casedetails.css";
import { Outlet, Link, useNavigate, Navigate } from "react-router-dom";
import { ShareContext } from "../../../context/ShareContext";
import * as Constants from "../../../constants";
import JisButton from "../../controls/jisButton";

function ViewParties({ caseId, parties = null, isAction = false }) {
  const { activePage, token, profile, frequentData, setIsExpired } =
    useContext(ShareContext);
  const [loading, setLoading] = useState(false);
  const [_parties, setParties] = useState(parties);

  useEffect(() => {
    /* if(parties==null){
                 onLoad();
                } */
  }, [parties]);

  const onLoad = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/case-details/${caseId}/parties`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await resp.json();
      if (data.code == 0) {
        setParties(data.parties);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  return (
    <div>
      {isAction && (
        <div style={{ textAlign: "right" }}>
          <button className="add-addition-document-btn btn-solid add-party-btn">
            Add Party
          </button>
        </div>
      )}
      <div className="table">
        <div class="table-header">
          <p>Parties </p>
        </div>

        <div className="table-wrapper">
          <table className="case-details-table full-border">
            <thead>
              <tr>
                <th className="col-title">Name</th>
                <th className="col-medium">Party Type</th>
                <th className="col-title">Legal Counsel</th>
                <th>Phone</th>
                <th className="col-title">Email</th>
              </tr>
            </thead>
            <tbody>
              {_parties.map((opt) => (
                <tr key={opt.id}>
                  <td>
                    {opt.firstName || opt.lastName
                      ? `${opt.firstName} ${opt.lastName ?? ""}`
                      : "N/A"}
                    {/* {opt.firstName} {opt.lastName ?? ""} */}
                  </td>
                  <td>{opt.title || "N/A"}</td>
                  <td>
                    {opt.legalcounsel != null
                      ? `${opt.legalcounsel.firstName} ${
                          opt.legalcounsel.lastName ?? ""
                        }`
                      : "N/A"}
                  </td>
                  <td>{opt.primaryContactNumber || "N/A"}</td>
                  <td>{opt.primaryEmail || "N/A"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ViewParties;
